module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.breadCrumbList), function(item, idx) {
    return _c('li', {
      key: idx,
      staticClass: "active",
      on: {
        "click": function($event) {
          _vm.routeTo(idx)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])], 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon ion-home"
  }), _vm._v("Home\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6196f23a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Breadcrumb.vue
// module id = 744
// module chunks = 1